import { __awaiter, __generator } from '../../node_modules/tslib/tslib.es6.js';
import { disarmMutation, queryGetArmState, pollArmStateQuery } from './armDisarm.gql.js';

var setDisarmAsync = function (giid, code, client) { return __awaiter(void 0, void 0, void 0, function () {
    var result, armStateDisarm, e_1, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, client.mutate({
                        mutation: disarmMutation,
                        variables: { giid: giid, code: code },
                    })];
            case 1:
                result = _a.sent();
                armStateDisarm = result.data.armStateDisarm;
                return [2 /*return*/, armStateDisarm];
            case 2:
                e_1 = _a.sent();
                error = e_1;
                if (!error.networkError) {
                    throw e_1;
                }
                return [2 /*return*/, null];
            case 3: return [2 /*return*/];
        }
    });
}); };
var getPollArmStateAsync = function (giid, transactionId, futureState, client) { return __awaiter(void 0, void 0, void 0, function () {
    var result, armStateChangePollResult, e_2, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, client.query({
                        query: pollArmStateQuery,
                        variables: { giid: giid, transactionId: transactionId, futureState: futureState },
                    })];
            case 1:
                result = _a.sent();
                armStateChangePollResult = result.data.installation.armStateChangePollResult;
                return [2 /*return*/, armStateChangePollResult];
            case 2:
                e_2 = _a.sent();
                error = e_2;
                if (!error.networkError) {
                    throw e_2;
                }
                return [2 /*return*/, null];
            case 3: return [2 /*return*/];
        }
    });
}); };
var getArmStateAsync = function (giid, client) { return __awaiter(void 0, void 0, void 0, function () {
    var result, armState, e_3, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, client.query({
                        query: queryGetArmState,
                        variables: { giid: giid },
                    })];
            case 1:
                result = _a.sent();
                armState = result.data.installation.armState;
                return [2 /*return*/, armState];
            case 2:
                e_3 = _a.sent();
                error = e_3;
                if (!error.networkError) {
                    throw e_3;
                }
                return [2 /*return*/, null];
            case 3: return [2 /*return*/];
        }
    });
}); };

export { getArmStateAsync, getPollArmStateAsync, setDisarmAsync };
